export default __webpack_public_path__ + "static/media/I0001.8cf592c5.png";